import { render, staticRenderFns } from "./StockViewTransfer.vue?vue&type=template&id=1fcca68d&scoped=true"
import script from "./StockViewTransfer.vue?vue&type=script&lang=js"
export * from "./StockViewTransfer.vue?vue&type=script&lang=js"
import style0 from "./StockViewTransfer.vue?vue&type=style&index=0&id=1fcca68d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcca68d",
  null
  
)

export default component.exports